import _ from 'underscore';
import Constants from '../constants/constants';
import { formAValidation } from './formaValidation';
import { formbValidation } from './formbValidation';
import { formcValidation } from './formcValidation';
import { tcmValidation } from './tcmValidation';
import { subdivisionStore } from '../stores/subdivision';

let regex = Constants.Regex;
let TYPES = Constants.RestrictionTypes;

function sanitizeInput(validChars, inputString) {
    let inputRegex = new RegExp('[^' + validChars + ']', 'g');
    return inputString.replace(inputRegex, '');
}

function flagsValid(flags) {
    let flag, foundError = false, flagsWithErrors = JSON.parse(JSON.stringify(flags));

    for (let i = 0; i < flagsWithErrors.length; i++) {
        flag = flagsWithErrors[i];//add it to the new array
        flag.errors = [];
        let index = "_" + i;

        if (flag.mp.length < 1) {
            foundError = true;
            flag.errors.push({ field: "mp" + index, error: "Mp: Please fill out this field." })
        }

        //https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
        if (!String.prototype.endsWith) {
            String.prototype.endsWith = function (searchString, position) {
                let subjectString = this.toString();
                if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                    position = subjectString.length;
                }
                position -= searchString.length;
                let lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
        }

        else if (isNaN(flag.mp)) {
            let mes = "Please enter a valid Mp";
            foundError = true;
            if (typeof flag.mp === 'string' && flag.mp.endsWith(".")) {
                mes = "Mp must have a number after the decimal"
            }
            flag.errors.push({ field: "mp" + index, error: mes })
        }

        if (flag.subdivision.length < 1) {
            foundError = true;
            flag.errors.push({ field: "subdivision" + index, error: "Subdivision: Please fill out this field." })
        }
        else if (flag.subdivision.match(/\d+/g) != null) {
            foundError = true;
            flag.errors.push({ field: "subdivision" + index, error: "Please enter a valid subdivision" })
        }


    }

    return { valid: !foundError, flags: flagsWithErrors };
}

function validateMps(startMp, startMpSuffix, endMp, endMpSuffix) {
    let errorList = [];
    let enteredStartMp = false;
    let enteredEndMp = false;
    let mpRegex = new RegExp(regex.mpRegex);
    let suffixRegex = new RegExp(regex.suffixRegex);

    if (!startMp || startMp.length === 0) {
        errorList.push({ field: 'workStartMp', message: 'From MP: Please fill out this field', type: 'error' });
    }
    else if (!mpRegex.test(startMp)) {
        errorList.push({ field: 'workStartMp', message: 'From MP: must be in format 9999.9', type: 'error' });
    }
    else {
        //validate the MP against the ranges from the MF
        enteredStartMp = true;
    }

    if (startMpSuffix && startMpSuffix.length !== 0) {
        if (!suffixRegex.test(startMpSuffix)) {
            errorList.push({
                field: 'workStartMpSuffix',
                message: 'From MP Sfx: must be a single letter',
                type: 'error'
            });
        }
    }

    if (!endMp || endMp.length === 0) {
        errorList.push({ field: 'workEndMp', message: 'To MP: Please fill out this field', type: 'error' });
    }
    else if (!mpRegex.test(endMp)) {
        errorList.push({ field: 'workEndMp', message: 'To MP: must be in format 9999.9', type: 'error' });
    }
    else {
        enteredEndMp = true;
    }

    if (endMpSuffix && endMpSuffix.length !== 0) {
        if (!suffixRegex.test(startMpSuffix)) {
            errorList.push({
                field: 'workEndMpSuffix',
                message: 'To MP Sfx: must be a single letter',
                type: 'error'
            });
        }
    }

    if (enteredStartMp && enteredEndMp) {
        if (parseFloat(startMp) === parseFloat(endMp) && endMpSuffix === startMpSuffix) {
            errorList.push({ field: 'workEndMp', message: 'From and To MPs must not be the same', type: 'error' });
        }
    }

    return errorList;
}

function validateFormCMps(startMp, startMpSuffix, endMp, endMpSuffix) {
    let errorList = [];
    let mpRegex = new RegExp(regex.mpRegex);
    let suffixRegex = new RegExp(regex.suffixRegex);

    if (!startMp || startMp.length === 0) {
        errorList.push({ field: 'workStartMp', message: 'From MP: Please fill out this field', type: 'error' });
    }
    else if (!mpRegex.test(startMp)) {
        errorList.push({ field: 'workStartMp', message: 'From MP: must be in format 9999.9', type: 'error' });
    }

    if (startMpSuffix && startMpSuffix.length !== 0) {
        if (!suffixRegex.test(startMpSuffix)) {
            errorList.push({
                field: 'workStartMpSuffix',
                message: 'From MP Sfx: must be a single letter',
                type: 'error'
            });
        }
    }

    if (!endMp || endMp.length === 0) {
        errorList.push({ field: 'workEndMp', message: 'To MP: Please fill out this field', type: 'error' });
    }
    else if (!mpRegex.test(endMp)) {
        errorList.push({ field: 'workEndMp', message: 'To MP: must be in format 9999.9', type: 'error' });
    }

    if (endMpSuffix && endMpSuffix.length !== 0) {
        if (!suffixRegex.test(startMpSuffix)) {
            errorList.push({
                field: 'workEndMpSuffix',
                message: 'To MP Sfx: must be a single letter',
                type: 'error'
            });
        }
    }

    return errorList;
}

/**
 * function to compare two suffixes. considers null, empty string, white space to all be equivilant.
 * @param sufOne
 * @param sufTwo
 */
function suffixesMatch(sufOne, sufTwo) {
    //console.log("comparing suffixes: ["+ sufOne +"] === [" + sufTwo + "]");
    sufOne = sufOne ? sufOne.trim() : "";
    sufTwo = sufTwo ? sufTwo.trim() : "";
    if (sufOne === sufTwo) {
        //console.log('equal');
        return true;
    }
    //console.log('not equal');
    return false;
}

function stringIsNullOrEmpty(str) {
    return (!str) || (str.trim().length === 0)
}

/**
 * Checks to see if the MP falls into any of the given ranges
 * @param mp
 * @param suffix
 * @param ranges
 * @returns {boolean}
 */
function mpInRange(mp, suffix, ranges) {
    mp = parseFloat(mp);
    let inRange = false;
    _.each(ranges, function (range) {
        if (range != null) {
            let mpInRange = (range.from <= mp && mp <= range.to) || (range.from >= mp && mp >= range.to);
            let suffixMatch = suffixesMatch(suffix, range.sfx);
            if (mpInRange && suffixMatch) {
                inRange = true;
            }
        }
    });
    return inRange;
}

function mpInRangeSuffix(mp, ranges) {
    mp = parseFloat(mp);
    let inRange = false;
    _.each(ranges, function (range) {
        if (range != null) {
            let inRangeMp = (range.from <= mp && mp <= range.to) || (range.from >= mp && mp >= range.to);
            if (inRangeMp)
                inRange = true;
        }
    });
    return inRange;
}


/**
 * checks if a form is valid for the given user type (dispatcher or field user)
 * @param _form
 * @param userType
 * @param printLata
 * @returns {*}
 */
function checkFormValidity(_form, userType, printLata) {
    let errors = [];
    let warnings = [];
    let mpRegex = new RegExp(regex.mpRegex);
    let suffixRegex = new RegExp(regex.suffixRegex);
    let typeValidation;
    let value = "";
    let mpErrors = [];

    //for all required field/format validations, these are handled client side and stored in the form store onBlur.
    //all storeErrors are passed in to this function
    //check each field on the form for validators.

    if (!printLata) {
        errors.push({
            field: 'printLata',
            message: 'Print LATA: Please fill out this field in the settings menu',
            type: 'error'
        });
    }

    if (_form.type === TYPES.C) {

        if (_form.subdivisions && _form.subdivisions[0] !== 'ALL' && _form.subdivisions.length < 2 && _form.fromLocation.length === 0 && _form.toLocation.length === 0) {

            mpErrors = validateFormCMps(_form.workStartMp, _form.workStartMpSuffix, _form.workEndMp, _form.workEndMpSuffix);
            //If there are MP errors, add them to the list
            if (mpErrors.length > 0) {
                mpErrors.map((e) => errors.push(e))
            }

            if (_form.workStartMp !== "") {
                if (!mpInRange(_form.workStartMp, _form.workStartMpSuffix, subdivisionStore.getFormCSubData().milePostRangeList)) {
                    value = _form.workStartMp + _form.workStartMpSuffix;
                    errors.push({
                        field: 'workStartMp',
                        message: `MP ${value} not found in subdivision`,
                        type: 'error'
                    });
                }
            }

            if (_form.workEndMp !== "") {
                if (!mpInRange(_form.workEndMp, _form.workEndMpSuffix, subdivisionStore.getFormCSubData().milePostRangeList)) {
                    value = _form.workEndMp + _form.workEndMpSuffix;
                    errors.push({
                        field: 'workEndMp',
                        message: `MP ${value} not found in subdivision`,
                        type: 'error'
                    });
                }
            }
        }
    }

    if (_form.type === TYPES.TCM) {
        if (_form.fromLocation.length === 0 && _form.toLocation.length === 0) {

            mpErrors = validateFormCMps(_form.workStartMp, _form.workStartMpSuffix, _form.workEndMp, _form.workEndMpSuffix);
            //If there are MP errors, add them to the list
            if (mpErrors.length > 0) {
                mpErrors.map((e) => errors.push(e))
            }

            if (_form.workStartMp !== "") {
                if (!mpInRange(_form.workStartMp, _form.workStartMpSuffix, subdivisionStore.getFormCSubData().milePostRangeList)) {
                    value = _form.workStartMp + _form.workStartMpSuffix;
                    errors.push({
                        field: 'workStartMp',
                        message: `MP ${value} not found in subdivision`,
                        type: 'error'
                    });
                }
            }

            if (_form.workEndMp !== "") {
                if (!mpInRange(_form.workEndMp, _form.workEndMpSuffix, subdivisionStore.getFormCSubData().milePostRangeList)) {
                    value = _form.workEndMp + _form.workEndMpSuffix;
                    errors.push({
                        field: 'workEndMp',
                        message: `MP ${value} not found in subdivision`,
                        type: 'error'
                    });
                }
            }
        }
    }

    //Form A & B specific validations
    if (_form.type === TYPES.A || _form.type === TYPES.B) {
        //Validate the MPs
        mpErrors = validateMps(_form.workStartMp, _form.workStartMpSuffix, _form.workEndMp, _form.workEndMpSuffix);

        //If there are MP errors, add them to the list
        if (mpErrors.length > 0) {
            mpErrors.map((e) => errors.push(e))
        }

        if (_form.shortFlagOneMpSuffix != null &&
            _form.shortFlagOneMpSuffix.length !== 0 &&
            (_form.shortFlagOneMp == null || _form.shortFlagOneMp === "")) {
            errors.push({ field: 'shortFlagOneMp', message: `Short Flag One: Please enter an MP value`, type: 'error' });
        }

        if (_form.shortFlagTwoMpSuffix != null &&
            _form.shortFlagTwoMpSuffix.length !== 0 &&
            (_form.shortFlagTwoMp == null || _form.shortFlagTwoMp === "")) {
            errors.push({ field: 'shortFlagTwoMp', message: `Short Flag Two: Please enter an MP value`, type: 'error' })
        }

        if (_form.shortFlagOneMp && _form.shortFlagOneMp.length !== 0) {
            if (!mpInRangeSuffix(_form.shortFlagOneMp, subdivisionStore.getSubData().milePostRangeList)) {
                value = _form.shortFlagOneMp + _form.shortFlagOneMpSuffix;
                errors.push({
                    field: 'shortFlagOneMp',
                    message: `From Short Flag One MP: ${value} not found in TSS ranges`,
                    type: 'error'
                });
            }
            if (!mpRegex.test(_form.shortFlagOneMp)) {
                errors.push({
                    field: 'shortFlagOneMp',
                    message: 'From Short Flag MP: must be in format 9999.9',
                    type: 'error'
                });
            }
        }

        if (_form.shortFlagOneMpSuffix && _form.shortFlagOneMpSuffix.length !== 0) {
            if (!mpInRange(_form.shortFlagOneMp, _form.shortFlagOneMpSuffix, subdivisionStore.getSubData().milePostRangeList)) {
                value = _form.shortFlagOneMp + _form.shortFlagOneMpSuffix;
                errors.push({
                    field: 'shortFlagOneMp',
                    message: `From Short Flag One MP: ${value} not found in TSS ranges`,
                    type: 'error'
                });
            }
            if (!suffixRegex.test(_form.shortFlagOneMpSuffix)) {
                errors.push({
                    field: 'shortFlagOneMpSuffix',
                    message: 'From Short Flag MP Sfx: must be a single letter',
                    type: 'error'
                });
            }
        }

        if (_form.shortFlagTwoMp && _form.shortFlagTwoMp.length !== 0) {
            if (!mpInRangeSuffix(_form.shortFlagTwoMp, subdivisionStore.getSubData().milePostRangeList)) {
                value = _form.shortFlagTwoMp + _form.shortFlagTwoMpSuffix;
                errors.push({
                    field: 'shortFlagTwoMp',
                    message: `From Short Flag Two MP: ${value} not found in TSS ranges`,
                    type: 'error'
                });
            }
            if (!mpRegex.test(_form.shortFlagTwoMp)) {
                errors.push({
                    field: 'shortFlagTwoMp',
                    message: 'To Short Flag MP: must be in format 9999.9',
                    type: 'error'
                });
            }

        }

        if (_form.shortFlagTwoMpSuffix && _form.shortFlagTwoMpSuffix.length !== 0) {
            if (!mpInRange(_form.shortFlagTwoMp, _form.shortFlagTwoMpSuffix, subdivisionStore.getSubData().milePostRangeList)) {
                value = _form.shortFlagTwoMp + _form.shortFlagTwoMpSuffix;
                errors.push({
                    field: 'shortFlagTwoMp',
                    message: `From Short Flag Two MP: ${value} not found in TSS ranges`,
                    type: 'error'
                });
            }
            if (!suffixRegex.test(_form.shortFlagTwoMpSuffix)) {
                errors.push({
                    field: 'shortFlagTwoMpSuffix',
                    message: 'To Short Flag MP Sfx: must be a single letter',
                    type: 'error'
                });
            }
        }


        if ((!_form.reason || _form.reason.length === 0) && (_form.type != TYPES.C && _form.type != TYPES.TCM)) {
            errors.push({ field: 'reason', message: 'Reason: Please fill out this field', type: 'error' })
        }



        //at least one track is selected
        if ((_form.tracks.filter(function (tr) {
            return tr.checked === true;
        }).length < 1) && (_form.type != TYPES.C && _form.type != TYPES.TCM)) {
            errors.push({ field: 'tracks', message: 'Tracks: Please make a selection.', type: 'error' })
        }

        if (_form.excludedGuids && _form.excludedGuids.length > 0) {
            if (!_form.comments || _form.comments.length === 0) {
                errors.push({
                    field: 'comments',
                    message: 'A comment is required to exclude a track section between the mileposts.',
                    type: 'error'
                })
            }
        }

        if (_form.timezone == null || _form.timezone === "") {
            errors.push({
                field: 'issuedTime',
                message: 'Unable to load Time Zone for subdivision. Please reload schematic',
                type: 'error'
            })
        }

        if (_form.timeTableDirection == null || _form.timeTableDirection === "") {
            errors.push({
                field: 'timeTableDirection',
                message: 'Unable to load Default Direction for subdivision. Please reload schematic',
                type: 'error'
            })
        }

    }
    if (_form.type === TYPES.B) {
        typeValidation = formbValidation.checkFormValidity(_form, userType)
    }
    else if (_form.type === TYPES.A) {
        typeValidation = formAValidation.checkFormValidity(_form, userType)
    }
    else if (_form.type === TYPES.C) {
        typeValidation = formcValidation.checkFormValidity(_form, userType)
    }
    else if (_form.type === TYPES.TCM) {
        typeValidation = tcmValidation.checkTCMValidity(_form, userType)
    }

    if (typeValidation) {
        let isValid = errors.length === 0 && typeValidation.isValid;
        let errorsList = errors.concat(typeValidation.errors);
        let warningsList = warnings.concat(typeValidation.warnings);

        return { isValid: isValid, errors: errorsList, warnings: warningsList }
    }
    else {
        return { isValid: errors.length === 0, errors: errorsList, warnings: warningsList }
    }
}

export const formValidation = {
    checkFormValidity,
    regex,
    suffixesMatch,
    stringIsNullOrEmpty,
    checkBFlagValidity: flagsValid,
    sanitizeInput,
    mpInRange
};
